import React, {useEffect} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {updateStepsVordaecher,
        updateWrapperIndexVordaecher,
        updateGlasartVordaecher
        } from '../../../../store/actions/vordaecher';
import {glastoenung} from '../../../../../assets/images/data';
import scrollToElement from '../../../../module/scrollToElement';


const Step_2 = (props) => {

   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
        const {glasart} = props.data[props.modell_index];
        let glasart_wrapper = document.querySelectorAll('.glasArtWrapperItems');
        let glasart_index = props.data[props.modell_index].wrapper[0].wrapper2;

        //remove check from box
        for (let i = 0; i < glasart_wrapper.length; i++) {
            glasart_wrapper[i].classList.remove('check');
        }
        //add check to box
        if(glasart && glasart_wrapper[glasart_index]) {
            glasart_wrapper[glasart_index].classList.add('check');
        }

        //scroll to Next Button Container
        if (glasart) scrollToElement();

        //update steps
        props.updateSteps(1);

        if(glasart || props.data[props.modell_index].allVisitedSteps) {
            props.updateSteps(2);
            props.setUpdateButtonActiveStepToFalse();
        } else {
            props.setUpdateButtonActiveStepToTrue()
        }

   }

   const updateGlasart = ev => {
        let glasart = ev.currentTarget.getAttribute('titel');
        let wrapperObject = {
            ident: 2,
            index: ev.currentTarget.getAttribute('index')
         }

        props.updateGlasart(glasart);
        props.updateWrapperIndex(wrapperObject);
        updateItems();
   }


    return (
        <div className="step_wrapper">
              <div className="step_icon_wrapper befestigungs_wrapper">
                <h2 className='step_header handlauf'>Welche Glastönung?</h2>
                <div className="inner-befestigungs-wrapper">
                    {glastoenung.map((elem, index) => (
                        <div style={{background: `#${elem.color}`}} className="glasArtWrapperItems" onClick={updateGlasart} key={index} index={index} titel={elem.titel}>
                            <p style={elem.titel === 'Anthrazit'? {color: 'white', margin: '0'}:{color: '#212529', margin: '0'}}>{elem.titel}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        modell_index: state.vordaecherReducer.modell_index,
        modell_type: state.vordaecherReducer.modell_type,
        data: state.vordaecherReducer.data
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updateSteps: ev => dispatch(updateStepsVordaecher(ev)),
      updateWrapperIndex: ev => dispatch(updateWrapperIndexVordaecher(ev)),
      updateGlasart: ev => dispatch(updateGlasartVordaecher(ev))

   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_2);
